module.exports = __webpack_public_path__ + "img/schema 3 - FR.b2ba56eb.svg";